module.exports = __webpack_public_path__ + "static/media/purple-s.2ce42997.svg";